import { render, staticRenderFns } from "./TopNavigationNotifications.vue?vue&type=template&id=434da2d9&scoped=true&"
import script from "./TopNavigationNotifications.vue?vue&type=script&lang=js&"
export * from "./TopNavigationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TopNavigationNotifications.vue?vue&type=style&index=0&id=434da2d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434da2d9",
  null
  
)

export default component.exports